import {ChangeDetectorRef, Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {BuilderSectionsInteractionService} from "../../../../../../builder-sections-interaction.service";
import {HeroSectionHelper} from "../hero-section.helper";

@Component({
    selector: 'db-a-type-hero-section',
    templateUrl: './a-type-hero-section.component.html',
    styleUrl: './a-type-hero-section.component.scss',
    standalone: false
})
export class ATypeHeroSectionComponent implements OnInit, OnChanges {
  constructor(
    private _cdRef: ChangeDetectorRef,
    private _helper: HeroSectionHelper,
    private _builderInteractionsService: BuilderSectionsInteractionService) {
  }
  @Input() logoTitle!: string;
  @Input() generationFinished!: boolean;
  @Input() generatedTexts: any;
  isEcommerce: boolean = false;
  showHeaderSection: boolean = false;
  openMenu: boolean = false;
  isMobile: boolean;
  menuPages: any;
  showHeaderBg: boolean = false;
  showBgImage: boolean = true;
  fadeInMenuElements: boolean[] = [];
  fadeInContentElements: boolean[] = [];
  activeTheme: string = this._builderInteractionsService.activeTheme.value.toLowerCase();
  styles: any;

  ngOnInit() {
    this.isMobile = this._helper.isMobile();
    this.menuPages = this._helper.getMenuPages();
    this.fadeInMenuElements = this._helper.createFadeArray(this.menuPages.length || 5);
    this.fadeInContentElements = this._helper.createFadeArray(3);
    this.styles = this._helper.getInitialStyles();
    this.setColor();
  }

  startFadeInSequence() {
    if (this.fadeInMenuElements.length) {
      this._helper.fadeInElements(this.fadeInMenuElements, this._cdRef, () => {
        this.fadeInHeaderButton();
      });
    }
    else {
      this.fadeInHeaderButton();
    }
  }

  fadeInHeaderButton(): void {
    setTimeout(() => {
      this.showHeaderBg = true;
      this._cdRef.markForCheck();
    }, 700);

    setTimeout(() => {
      this.fadeInContentSection();
    }, 1700);
  }


  fadeInContentSection(): void {
    if (this.fadeInContentElements.length) {
      this.fadeInContentElements.forEach((_, index) => {
        setTimeout(() => {
          this.fadeInContentElements[index] = true;
          this._cdRef.markForCheck();

          if (index === this.fadeInContentElements.length - 1) {
            setTimeout(() => {
              this.showBgImage = false;
              this._cdRef.markForCheck();
            }, 2700);
          }

        }, index * 200); // Delay each fade-out by 150ms
      });
    }
    else {
      this.showBgImage = false;
      this._cdRef.markForCheck();
    }
  }


  ngOnChanges(changes: SimpleChanges) {
    if (changes['generatedTexts'] && changes['generatedTexts'].currentValue) {
      this.isEcommerce = this._helper.isEcommerceType(changes['generatedTexts'].currentValue);
      setTimeout(() => {
        this.showHeaderSection = true;
        this._cdRef.markForCheck();
      }, 300);
      setTimeout(() => {
        this.startFadeInSequence();
        this._cdRef.detectChanges();
      }, 1200);
    }
  }

  setColor() {
    this._helper.getInitialStyles();
  }

  toggleMenu() {
    this.openMenu = this._helper.toggleMenu(this.openMenu);
  }
}
